import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { MdChevronRight } from "react-icons/md";
import { ManagerProgressContext } from "../../contexts/managerProgres";
import InputQuestion from "../inputQuestion/inputQuestion";
import "./_cardQuestion.scss";

function CardQuestion({
    title,
    options,
    postDataQuestion,
    subTemaId,
    idForm,
    answer,
    lastQuestion,
    finishTema,
}) {
    let historyInputChosen = answer;
    const containerQuestionRef = useRef(null);
    const clickShowRef = useRef(null);
    const { managerBtn, concluded } = useContext(ManagerProgressContext);
    const [isOptionSelected, setIsOptionSelected] = useState(false);

    useEffect(() => {
        const inputSelector = document.querySelectorAll(
            `input[name='${subTemaId}']`
        );

        if (historyInputChosen === null || historyInputChosen === undefined)
            return;

        inputSelector.forEach((el, index) => {
            const dataOrder = el.getAttribute("data-order");
            const element = document.getElementById(historyInputChosen);
            
            if (element) {
                const dataOrderAnswer = element.getAttribute("data-order");

                if (dataOrder < dataOrderAnswer) {
                    el.classList.add("input-onClick");
                }
            }

            if (Number(el.value) === historyInputChosen) {
                el.setAttribute("checked", "");
            }

            if (managerBtn === false) {
                el.disabled = true;
            } else {
                el.disabled = false;
            }
        });

        let statusQuestionAswered = historyInputChosen && true;

        if (statusQuestionAswered) {
            clickShowRef.current.style.borderLeft =
                "4px solid var(--color-tema)";
            setIsOptionSelected(true);
        } else {
            clickShowRef.current.style.borderLeft = "none";
            setIsOptionSelected(false);
        }
    }, [historyInputChosen, subTemaId, managerBtn]);

    function showContainer() {
        const boxShowQuestion = document.querySelectorAll(".box-show-question");
        const containerCardquestion = document.querySelectorAll(
            ".container-card-questionario"
        );
        const form = document.querySelectorAll("form");
        const formArray = [...form];
        const inputChosen = document.querySelector(
            `input[name='${subTemaId}']:checked`
        );

        formArray.forEach((formEl, index) => {
            const container = containerCardquestion[index];
            const box = boxShowQuestion[index];

            if (formEl.id === `form-${subTemaId - 1}`) {
                const isShown = formEl.classList.contains("show-form");

                if (!isShown) {
                    formEl.classList.add("show-form");
                    container.classList.add("show");
                    box.classList.add("box-show-question2");
                    formEl.style.display = "block";

                    setTimeout(() => {
                        containerQuestionRef.current?.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    }, 100);
                } else {
                    formEl.classList.remove("show-form");
                    container.classList.remove("show");
                    box.classList.remove("box-show-question2");
                    formEl.style.display = "none";
                }
            } else {
                formEl.classList.remove("show-form");
                formEl.style.display = "none";
                container.classList.remove("show");
                box.classList.remove("box-show-question2");
            }
        });

        // Borda esquerda (estética da resposta)
        const statusQuestionAswered = inputChosen && true;
        clickShowRef.current.style.borderLeft = statusQuestionAswered
            ? "4px solid var(--color-tema)"
            : "none";
    }

    function registerAnswerQuestion() {
        const form = document.querySelectorAll("form");
        const boxShowQuestion = document.querySelectorAll(".box-show-question");
        const containerCardquestion = document.querySelectorAll(
            ".container-card-questionario"
        );
        const inputChosen = document.querySelector(
            `input[name='${subTemaId}']:checked`
        );

        postDataQuestion(subTemaId, inputChosen.value);

        for (let elForm in form) {
            if (form[elForm].id === `form-${subTemaId - 1}`) {
                form[elForm].style.display = "none";
                containerCardquestion[elForm].classList.remove("show");
                form[elForm].classList.remove("show-form");

                boxShowQuestion[elForm].classList.remove("box-show-question2");
            }
        }

        let statusQuestionAswered = inputChosen && true;

        if (statusQuestionAswered) {
            clickShowRef.current.style.borderLeft =
                "4px solid var(--color-tema)";
        } else {
            clickShowRef.current.style.borderLeft = "none";
        }
    }

    function activeSelection(e) {
        if (managerBtn !== true) return;

        const inputSelector = document.querySelectorAll(
            `input[name='${subTemaId}']`
        );
        const inputChecked = e.target.getAttribute("data-order");

        if (inputChecked === 0) return;

        setIsOptionSelected(true);

        inputSelector.forEach((el) => {
            if (Number(el.getAttribute("data-order")) === 0) return;

            if (el.getAttribute("data-order") < inputChecked) {
                el.classList.add("input-onClick");
            } else {
                el.classList.remove("input-onClick");
            }
        });
    }

    function submitQuestion() {
        const btnSubmitQuestion =
            document.querySelector(".btn-send-request")?.offsetTop;
        const inputChosen = document.querySelector(
            `input[name='${subTemaId}']:checked`
        );

        if (lastQuestion && finishTema && !answer) {
            window.scroll(0, btnSubmitQuestion);
            localStorage.setItem(
                "@tetse",
                JSON.stringify([subTemaId, inputChosen.value])
            );
        }

        registerAnswerQuestion();
        handleClose();

        setTimeout(() => {
            const allQuestions = Array.from(document.querySelectorAll('.container-card-questionario'));
            const currentIndex = allQuestions.findIndex(el => el.classList.contains(subTemaId));
            
            if (currentIndex !== -1) {
                const currentQuestion = allQuestions[currentIndex];
                const headerOffset = 150;
                const elementPosition = currentQuestion.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                
                window.scrollTo({
                     top: offsetPosition,
                     behavior: "smooth"
                });
            }
        }, 150);
    }

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div
            ref={containerQuestionRef}
            className={`container-card-questionario ${subTemaId}`}
        >
            <div
                ref={clickShowRef}
                onClick={showContainer}
                className="box-show-question"
            >
                <p>{title}</p>
                <MdChevronRight className="icon-click" />
            </div>
            <form id={`form-${idForm - 1}`}>
                {options.map((el) => (
                    <InputQuestion
                        activeSelection={activeSelection}
                        key={el.id}
                        label={el.title}
                        id={el.id}
                        subTemaId={subTemaId}
                        order={el.order}
                    />
                ))}

                {!concluded && (
                    <button
                        type="button"
                        onClick={handleClickOpen}
                        className="btn-question"
                        disabled={!isOptionSelected}
                    >
                        Salvar
                    </button>
                )}

                <Dialog
                    open={open}
                    onClose={handleClose}
                    disableRestoreFocus
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Respondendo questionário"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Ao confirmar você responderá a seguinte questão,
                            deseja enviar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Não</Button>
                        <Button onClick={submitQuestion} autoFocus>
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>
            </form>
        </div>
    );
}
export default CardQuestion;



